import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx._visible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx._visible) = $event)),
    onCancel: _ctx.handleCancel
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: _ctx.handleCancel }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleSave,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "Task Name CN",
              name: "taskNameCn"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.form.taskNameCn,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.taskNameCn) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Task Category",
              name: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "please select",
                  value: _ctx.form.category,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.category) = $event)),
                  disabled: _ctx.formType === 'edit',
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Dealer Feedback",
              name: "isDealerFeedback"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.form.isDealerFeedback,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.isDealerFeedback) = $event)),
                  disabled: _ctx.formType === 'edit'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.form.isDealerFeedback === '1')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "Expiration Date",
                  name: "expirationDate"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_date_picker, {
                      disabled: _ctx.formType === 'edit',
                      value: _ctx.form.expirationDate,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.expirationDate) = $event)),
                      format: _ctx.dateFormat,
                      valueFormat: _ctx.dateFormat,
                      placeholder: "Please select",
                      "disabled-date": _ctx.disabledDate
                    }, null, 8, ["disabled", "value", "format", "valueFormat", "disabled-date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "Send to Region",
              name: "isSendToRegion"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.form.isSendToRegion,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.isSendToRegion) = $event)),
                  disabled: _ctx.formType === 'edit'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}